import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const fullWidthAccordionContainer = ({ theme }: { theme: Theme }) => css`
  .MuiAccordionSummary-root {
    background-color: ${theme.palette.primary[300]};
    color: ${theme.palette.primary.main};
    text-transform: uppercase;
    padding: 16px 16px !important;
    font-size: 20px !important;

    svg {
      color: ${theme.palette.primary.main} !important;
      transform: scale(1.4);
    }
  }
  &.MuiAccordion-root.MuiAccordion-rounded {
    border-radius: 0 !important;
  }
`
